// src/pages/HelpPage.js
import React from 'react';
import styles from './HelpPage.module.css';// Using the CSS Module
import Instructions from './components/Instructions';
import FAQs from './components/FAQs';
import Contact from './components/ContactUs';

const HelpPage = () => {
    return (
        <div className={styles.helpContainer}>
            <h1>Help & Support</h1>

            {/* Instructions Section (remains the same) */}
                <Instructions />
            {/* FAQs Section */}
                <FAQs />
            {/* Contact Us Section */}
                <Contact />

            {/* Quick Start Guide  */}
            {/* <QuickStartGuide /> */} 
</div>

    );
};

export default HelpPage;